import { render, staticRenderFns } from "./InviteBtnGroup.vue?vue&type=template&id=1fcc1ffc&scoped=true"
import script from "./InviteBtnGroup.vue?vue&type=script&lang=js"
export * from "./InviteBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./InviteBtnGroup.vue?vue&type=style&index=0&id=1fcc1ffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc1ffc",
  null
  
)

export default component.exports